module.exports = __webpack_public_path__ + "img/icon-questionmark.bd064d15.svg";